module.exports = __webpack_public_path__ + "media/images/top/mainimage03-c06acaedc85b76a4e6d9772bf2666a6b.png";